<!-- 新房 -->
<template>
  <div class="">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <div class="img_box">
      <div class="pc_img">
        <img alt="" :src="pcImg" style="width: 100%; " />
      </div>
      <div class="wap_img">
        <img alt="" :src="wapImg" style="width: 100%; " />
      </div>
    </div>
    <hr class="hr_1 mt0 mb30">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import SanTable from '../../components/SanTable.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetInitial, apiGetList, apiGetDetail, apiGetArea, apiGetCity } from '../../api/job.js';
import { apigetSetting } from '../../api/login.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    SanTable: SanTable,
    RightNav:RightNav,
  },
  data() {
    return {
      pcImg:'',
      wapImg:'',
    };
  },
  created() {
    if(this.$route.query.id==1){
      this.pcImg = 'static/picture/1-220224112343133.jpg'
      this.wapImg= 'static/picture/1-22022411232O15.jpg'
    }
    if(this.$route.query.id==2){
      this.pcImg = 'static/picture/1-22022411210H33.jpg'
      this.wapImg= 'static/picture/1-220224112052321.jpg'
    }
    if(this.$route.query.id==3){
      this.pcImg = 'static/picture/1-22022411192R15.jpg'
      this.wapImg= 'static/picture/1-220224111912137.jpg'
    }
    if(this.$route.query.id==4){
      this.pcImg = 'static/picture/1-22022411160H54.jpg'
      this.wapImg= 'static/picture/1-22022411162a26.jpg'
    }
    if(this.$route.query.id==5){
      this.pcImg = 'static/picture/1-220224111234157.jpg'
      this.wapImg= 'static/picture/1-22022411121XF.jpg'
    }
    if(this.$route.query.id==6){
      this.pcImg = 'static/picture/1-211130142556432.jpg'
      this.wapImg= 'static/picture/1-211130142441Y8.jpg'
    }
    if(this.$route.query.id==7){
      this.pcImg = 'static/picture/1-2111301429529C.jpg'
      this.wapImg= 'static/picture/1-211130142922357.jpg'
    }
    if(this.$route.query.id==8){
      this.pcImg = 'static/picture/1-211130143122593.jpg'
      this.wapImg= 'static/picture/1-211130143144Z2.jpg'
    }
    if(this.$route.query.id==9){
      this.pcImg = 'static/picture/1-211130143621T3.jpg'
      this.wapImg= 'static/picture/1-211130143603428.jpg'
    }
    if(this.$route.query.id==10){
      this.pcImg = 'static/picture/1-211130143T6263.jpg'
      this.wapImg= 'static/picture/1-211130143R9B1.jpg'
    }
  },
  methods: {
    //切换标签
    linkTitle(index,ids) {
      this.isTitle = index;
      this.ids = ids
      this.page = 1;
      this.saleList = [];
      this.getSaleList(this.estateType, this.price, this.house, this.area, this.nameAddress, this.page, this.pagesize);
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------brand.html  start----------------*/
.img_box{
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
.img_box img{
	max-width: 100%;
	margin: 0 auto;
	display: block;
}
.img_box .video_box{
	width: 100%;
	margin: 0 auto;
	position: relative;
}
.img_box .video_box .zhezhao{
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
	z-index: 555;
	overflow: hidden;
	cursor: pointer;
}
.img_box .video_box .zhezhao img{
	width: 100%;
	height: 100%;
	transition:all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc{
	display: block;
}
.img_box .video_box .zhezhao img.img_wap{
	display: none;
}
.img_box .video_box video{
	width: 100%;
}
/*------------brand.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Job/Index.vue